import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import { useMainStore } from '@/stores/main.js'
import { useRareItemsStore } from "@/stores/rareItems";
import { useLayoutStore } from '@/stores/layout.js'

import './css/main.css'

// Auth now lives in an httpOnly cookie set by the API (not readable/storable
// from JS) — withCredentials makes the browser send it automatically.
axios.defaults.withCredentials = true

// Init Pinia
const pinia = createPinia()

// Create Vue app
createApp(App).use(router).use(pinia).mount('#app')

// Init main store
// (auth/user data is fetched once by the router guard on the first navigation)
const mainStore = useMainStore();

// Init rare items store
const rareItemsStore = useRareItemsStore();
rareItemsStore.fetchRareItems();

// Auth: 401 response → logout
mainStore.setupAxiosInterceptors()

// Fetch sample data (for dashboard)
//mainStore.fetchSampleClients()
//mainStore.fetchSampleHistory()
//mainStore.fetchSampleProducts()
//mainStore.fetchSampleUpdates()

// Responsive layout control
const layoutStore = useLayoutStore(pinia)
layoutStore.responsiveLayoutControl()
window.onresize = () => layoutStore.responsiveLayoutControl()

// Dark mode
// Uncomment, if you'd like to restore persisted darkMode setting, or use `prefers-color-scheme: dark`. Make sure to uncomment localStorage block in src/stores/darkMode.js
// import { useDarkModeStore } from './stores/darkMode'

// const darkModeStore = useDarkModeStore(pinia)

// if (
//   (!localStorage['darkMode'] && window.matchMedia('(prefers-color-scheme: dark)').matches) ||
//   localStorage['darkMode'] === '1'
// ) {
//   darkModeStore.set(true)
// }

// Default title tag
const defaultDocumentTitle = 'Trade-Planet Admin Panel'

// Set document title from route meta
router.afterEach((to) => {
  document.title = to.meta?.title
    ? `${to.meta.title} — ${defaultDocumentTitle}`
    : defaultDocumentTitle
})
